import toastr from "toastr";
import "toastr/build/toastr.min.css";

/**
 * Display a toast notification with a specified type, title, and message.
 *
 * @typedef {'info' | 'warning' | 'error' | 'success'} toastType
 *
 * @param {toastType} toastType - The type of toast notification ('info', 'warning', 'error', 'success')
 * @param {string} title - The title of the toast notification
 * @param {string} message - The message to display in the toast notification
 * @param {number} [timeOut=5000] - Duration in milliseconds before the toast is automatically hidden
 * @param {number} [showDuration=300] - Duration in milliseconds for the fade-in effect
 */
const showToast = (toastType, title, message, timeOut = 5000, showDuration = 300) => {
  toastr.options = {
    positionClass: "toast-top-right",
    timeOut,
    extendedTimeOut: 1000,
    closeButton: false,
    debug: false,
    progressBar: true,
    preventDuplicates: false,
    newestOnTop: true,
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    showDuration,
    hideDuration: 300,
  };

  switch (toastType) {
    case "info":
      toastr.info(message, title);
      break;
    case "warning":
      toastr.warning(message, title);
      break;
    case "error":
      toastr.error(message, title);
      break;
    default:
      toastr.success(message, title);
      break;
  }
};

export default showToast;
